import React, { Component } from 'react';

export default class DateField extends Component {
    handleChange = (e) => {
        this.props.onChange(this.props.fieldDef.fieldId, e.target.value);
    };

    render() {
        const { fieldDef, value, hasError, errorMessage, disabled } = this.props;
        const isRequired = fieldDef.validation && fieldDef.validation.required;

        return (
            <div className="form-group">
                <label>
                    {fieldDef.label}
                    {isRequired && <span className="text-danger"> *</span>}
                </label>
                <input
                    type="date"
                    name={fieldDef.fieldId}
                    value={value || ''}
                    onChange={this.handleChange}
                    disabled={disabled}
                    className={hasError ? 'form-control is-invalid' : 'form-control'}
                />
                <div className={hasError ? 'inline-errormsg' : 'hidden'}>
                    <i className="fa fa-exclamation-circle" aria-hidden="true">
                        &nbsp;{errorMessage || 'This field is required.'}
                    </i>
                </div>
            </div>
        );
    }
}
